import { type FC, useEffect } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { trackEvent } from 'dibs-tracking';
import MakeOffer from 'dibs-icons/exports/legacy/MakeOffer';

import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from './PdpSharedPrivateOfferBanner.scss';

export const PdpSharedPrivateOfferBanner: FC<{ className?: string }> = ({ className = '' }) => {
    useEffect(() => {
        trackEvent({
            category: 'product',
            action: 'open offer pdp',
            label: 'pdp',
            isInteractiveEvent: false,
        });
    }, []);

    return (
        <div
            className={classnames(
                styles.container,
                dibsCss.bgGreen100,
                dibsCss.flex,
                dibsCss.itemsCenter,
                dibsCss.plSmall,
                dibsCss.prSmall,
                dibsCss.ptXsmall,
                dibsCss.pbXsmall,
                dibsCss.roundedXxsmall,
                className
            )}
        >
            <MakeOffer className={classnames(dibsCss.w20px, dibsCss.mrXsmall)} />
            <span className={dibsCss.sassyFontBodyTypeHeavy}>
                <FormattedMessage
                    id="abf.PdpSharedPrivateOfferBanner.text"
                    defaultMessage="You received an offer!"
                />
            </span>
        </div>
    );
};

export default PdpSharedPrivateOfferBanner;
